import { render, staticRenderFns } from "./ButtonVersion.vue?vue&type=template&id=1197877c&scoped=true"
import script from "./ButtonVersion.vue?vue&type=script&lang=js"
export * from "./ButtonVersion.vue?vue&type=script&lang=js"
import style0 from "./ButtonVersion.vue?vue&type=style&index=0&id=1197877c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1197877c",
  null
  
)

export default component.exports